import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import useSelectedAccessory from './useSelectedAccessory';

// "CODE" per the Wizard's vehicle parameters: same as vehicleId/eic, but
// stripped of characters it explicitly must not contain.
const sanitizeVehicleCode = (code) => (code || '').replace(/[.,/]/g, '');

// Gathers every dynamic dataLayer field the Wizard-aligned events need
// (Page View / Virtual Page View / Configurator Completion) from current
// app state, so call sites don't each re-derive it themselves.
const useTrackingContext = () => {
    const { i18n } = useTranslation();
    const { builderData, locationsData } = useSelector(state => state.data);
    const { gradeId, model, modelName, specification } = useSelector(state => state.config);
    const { locationCode } = useSelector(state => state.app);
    const { engine, body } = useSelectedAccessory();

    const grade = builderData?.grades?.find(item => item.id === gradeId);
    const dealer = locationsData?.find(item => item.shortName === locationCode);

    // Before builderData loads (grade/part selection steps), fall back to
    // whatever's already known: the eic picked with the grade, or - before
    // even that - the bare model id/name picked on the model selection step.
    const vehicleModel = builderData?.model?.name || modelName;
    const vehicleId = builderData?.eic || specification || model;

    const vehicle = builderData?.eic ? {
        name: [vehicleModel, body?.name, engine?.name, grade?.name].filter(Boolean).join(' '),
        code: sanitizeVehicleCode(vehicleId),
        price: builderData.price,
        body: body?.name,
        engine: engine?.name,
        engineType: engine?.type,
        // transmissionCode, not transmission - the latter is a translatable
        // display name, analytics needs the stable English value.
        gearbox: engine?.transmissionCode,
        grade: grade?.name,
    } : undefined;

    return {
        languageCode: i18n.language?.split('-')[0],
        vehicleModel,
        vehicleId,
        vehicle,
        dealerName: dealer?.name,
        dealerId: dealer?.shortName,
    };
};

export default useTrackingContext;
